export default "__VITE_ASSET__84371e64__"